<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="6"
        md="6"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Инофрмация о клиенте
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <h1>{{guest.first_name || '' }} {{guest.last_name || '' }}</h1>
                </v-col>


                <v-col cols="6">
                  Телефон : <h4>{{guest.phone }}</h4>
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                >
                  Примечания : <h4>{{guest.notes }}</h4>
                </v-col>

                <v-col
                  cols="6"
                  md="6"
                >
                  Email : <h4>{{guest.email }}</h4>
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                >
                  Дата создания : <h4>{{guest.created_at }}</h4>
                </v-col>


              </v-row>
            </v-container>
          </v-form>
          <div class="text-right">

          </div>
        </base-material-card>
      </v-col>

      <v-col
        cols="6"
        md="6"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Последние брони
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-data-table
                    :headers="headers"
                    :items="guest.reservations"
                    disable-sort
                    disable-filtering
                    disable-pagination
                    hide-default-footer
                  >

                    <template v-slot:item.status.name="{ item }">
                      <div class="d-flex justify justify-space-around">
                        <v-chip
                          class="ma-2"
                          style="color: white"
                          :color="item.status.color"
                        >
                          {{item.status.name}}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:no-data>
                      <v-btn color="primary">Reset</v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <div class="text-right">

          </div>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    export default {
      props : {
          id : {
            type : [String, Number]
          }
      },
      mounted() {
          this.$store.dispatch('guest/getGuest', {
            id : this.id
          })
        .then((data) => {
          this.guest = data;
        })
        .catch(e => console.log(e))
      },
      data(){
        return {
          headers: [
            {
              text: 'ID ',
              align: 'start',
              sortable: false,
              value: 'id',
            },
            {
              text: 'Ресторан ',
              align: 'start',
              sortable: false,
              value: 'restaurant.title',
            },
            {
              text: 'Дата бронирования ',
              align: 'start',
              sortable: false,
              value: 'restaurant.created_at',
            },
            {
              text: 'Статус ',
              align: 'start',
              sortable: false,
              value: 'status.name',
            }
          ],
          guest : {}
        }
      }
    }
</script>

<style scoped>

</style>
